import { orderConstants } from '@utils/constants';
import i18nTranslateValueFromOptions from '@/utils/i18nTranslateValueFromOptions';

export default function statusPaymentHTML(value) {
    const translatedValue = i18nTranslateValueFromOptions(value, '_common:statuses');

    switch (value.toUpperCase()) {
        case orderConstants.PAYMENT_STATUS.SUCCEEDED:
            return `<span class="status--succeeded">${translatedValue}</span>`;
        case orderConstants.PAYMENT_STATUS.FAILED:
            return `<span class="status--failed">${translatedValue}</span>`;
        default:
            return value;
    }
}
